<template>
  <header class="page-header">
    <!-- 左侧logo/网站名称 -->
    <div class="header-left" @click="goHome">
      <img v-if="logoUrl" :src="logoUrl" alt="网站logo" class="logo">
      <span v-else>{{ siteName }}</span>
    </div>

    <!-- 中间导航菜单 -->
    <nav class="header-nav">
      <ul>
        <li v-for="(item, index) in navItems" :key="index">
          <template v-if="item.type === 'link'">
            <a :href="item.uri">{{ item.title }}</a>
          </template>
          <template v-else>
            <router-link :to="item.uri">{{ item.title }}</router-link>
          </template>
        </li>
      </ul>
    </nav>

    <!-- 右侧用户信息 -->
    <div class="header-right">
      <a-dropdown v-if="isEnableLogin">
        <div v-if="isLoggedIn">
          <span style="margin-right: 10px;">{{ userInfo.nickname }}</span>
          <a-avatar :src="userAvatar" style="background-color: #1890ff">
            <template #icon><UserOutlined /></template>
          </a-avatar>
        </div>

        <div v-else>
          <span style="margin-right: 10px;">未登录</span>
          <a-avatar>
            <template #icon><UserOutlined /></template>
          </a-avatar>
        </div>
        <template #overlay>
          <a-menu>
            <template v-if="isLoggedIn">
              <a-menu-item>
                <a href="javascript:;" @click="goProfile">个人中心</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="logout">退出登录</a>
              </a-menu-item>
            </template>
            <template v-else>
              <a-menu-item>
                <a href="javascript:;" @click="login">登录</a>
              </a-menu-item>
              <a-menu-item v-if="isEnableSignUp">
                <a href="javascript:;" @click="signup">注册</a>
              </a-menu-item>
            </template>
          </a-menu>
        </template>
        <template #icon><UserOutlined /></template>
      </a-dropdown>
    </div>
  </header>
</template>

<script>
import { getSiteInfo } from '@/storage/site_info'
import { getAccessToken } from '@/storage/token'
import { UserOutlined } from '@ant-design/icons-vue'

export default {
  name: 'PageHeader',components: {
    UserOutlined
  },
  data() {
    return {
      logoUrl: '',
      siteName: '',
      isLoggedIn: false, // 从store获取登录状态
      isEnableSignUp: false,
      isEnableLogin: false,
      userAvatar: "", // 默认头像
      userInfo: {}, // 存储用户信息
      navItems: [
        // { type: 'router', title: '首页', uri: '/' },
      ]
    }
  },
  mounted() {
    const site = getSiteInfo()
    this.logoUrl = site.site_logo
    this.siteName = site.site_name
    this.isEnableSignUp = site.is_enable_sign_up
    this.isEnableLogin = site.is_enable_login
    this.navItems = site.header_menus
    this.fetchUserInfo()
  },
  methods: {
    goHome() {
      this.$router.push('/')
    },
    login() {
      // 跳转到登录页面
      const currentPath = this.$route.fullPath;
      this.$router.push(`/auth/login?from=${encodeURIComponent(currentPath)}`)
    },
    signup() {
      // 跳转到注册页面
      this.$router.push('/auth/signup')
    },
    async logout() {
      this.$store.dispatch('Logout').then(() => {
        this.isLoggedIn = false
        this.userInfo = {}
        location.reload()
      })
    },
    goProfile() {
      // 跳转到个人中心
      this.$router.push('/user/info')
    },
    async fetchUserInfo() {
      if (!getAccessToken()) {
        this.isLoggedIn = false
        return
      }
      this.isLoggedIn = true
      this.userInfo = {
        nickname: this.$store.state.user.nickname
      }
      // 更新用户头像
      if (this.$store.state.user.avatar) {
        this.userAvatar = this.$store.state.user.avatar
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 60px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-left {
  cursor: pointer;
}

.logo {
  height: 40px;
}

.header-nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.header-nav li {
  margin: 0 15px;
}

.header-nav a {
  text-decoration: none;
  color: #333;
}
</style>
